<div class="meeting-minute-rows">

  @for (row of controls; track trackRow($index, row); let index = $index) {
    <div class="meeting-minute-row" [formGroup]="row">

      <div class="meeting-minute-row-header">
        <span class="meeting-minute-row-index">Agreement {{ index + 1 }}</span>
        @if (!readonlyRows) {
          <button
            type="button"
            class="btn btn-outline-danger btn-icon remove-row-button"
            title="Remove agreement"
            (click)="onRemoveRow(index)">
            <i class="fa fa-solid fa-trash"></i>
          </button>
        }
      </div>

      <div class="row">
        <div class="col-lg-3 col-md-4">
          <input-field
            label="Date"
            [inputFormControl]="getControl(row, 'date')"
            [type]="'date'"
            [readonly]="readonlyRows">
          </input-field>
        </div>

        <div class="col-lg-9 col-md-8">
          <textarea-field
            label="Comment"
            placeholder="What was agreed"
            [textareaFormControl]="getControl(row, 'comment')"
            [readonly]="readonlyRows"
            [height]="100">
          </textarea-field>
        </div>
      </div>

    </div>
  } @empty {
    <div class="empty-text text-center text-muted py-3">
      @if (readonlyRows) {
        This meeting minute has no agreement.
      } @else {
        No agreement yet. Use "Add item" to create the first one.
      }
    </div>
  }

  @if (!readonlyRows) {
    <div class="add-row-bar">
      <button type="button" class="btn btn-primary" (click)="onAddRow()">
        <i class="fa fa-plus me-1"></i>Add item
      </button>
    </div>
  }

</div>
